import { cn } from "@/lib/utils";
import { CheckCircle, Clock, Users } from "lucide-react";

interface ProofBadgeProps {
  type: "verified" | "pending" | "community";
  className?: string;
}

export const ProofBadge = ({ type, className }: ProofBadgeProps) => {
  const variants = {
    verified: {
      icon: CheckCircle,
      label: "Verified",
      className: "bg-verified/10 text-verified",
    },
    pending: {
      icon: Clock,
      label: "Pending",
      className: "bg-pending/10 text-pending",
    },
    community: {
      icon: Users,
      label: "Community",
      className: "bg-primary/10 text-primary",
    },
  };

  const variant = variants[type];
  const Icon = variant.icon;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full",
        variant.className,
        className
      )}
    >
      <Icon className="w-3 h-3" />
      {variant.label}
    </span>
  );
};
